import React, { memo } from 'react';
import { Info } from '@app/components';
import { User, UserEmploymentNames, UserScheduleNames } from '@app/models';
import { useTranslation } from 'react-i18next';

interface Props {
  user: User;
}

function ProfileUserAdditionalInfo(props: Props) {
  const { user } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 w-full">
      <Info
        label={t('fieldOfActivity')}
        value={
          user.specializationOked?.nameRu || user.specialization || 'Не указано'
        }
      />
      <Info
        label="Занятость"
        value={
          user?.employment
            ? UserEmploymentNames[user.employment]
            : t('notSpecified')
        }
      />
      <Info
        label={t('schedule')}
        value={
          !!user.schedule ? UserScheduleNames[user.schedule] : t('notSpecified')
        }
      />
      <Info
        label={t('readyForBusinessTrips')}
        value={
          user.readyForBusinessTrips !== null
            ? user.readyForBusinessTrips
              ? t('yes')
              : t('no')
            : t('notSpecified')
        }
      />
      <Info
        label={t('additionalInformation')}
        value={
          !!user.additionalInformation
            ? user.additionalInformation
            : t('notSpecified')
        }
      />
    </div>
  );
}

export default memo(ProfileUserAdditionalInfo);
